// 本文件定义各种常量和枚举 - 此处认为枚举也是普通常量
// 自动生成的除外
import i18n from '../i18n/index.js'
import { ESig } from '@/pb/signaling_param_pb'

// 例如：localStorage的key相关的常量可以定义在这里
export const HIAR_GLASSES_TOKEN_CACHE = '_hiar_glasses_token_'

// 登录保持30天
export const ONE_DAY_MILLSECS = 30 * 24 * 3600 * 1000

export const NOTIFY_TYPE = Object.freeze({
  IM_MSG_RELAY_NTY: 103, // 邀请好友
  COC_NTY: 130, // 会议通知
  SYSTEM_NOTICE: 99999 // 系统通知
})

const HileiaErrorMin = 3000

export const HILEIA_HTTP_RETCODE = Object.freeze({
  Ok: 0, // 成功
  NOGRANT: 1026, // 未授权应用
  UserNotLogined: 1902,
  SignatureCheckFailed: HileiaErrorMin + 8, // 签名验证失败
  TokenCheckFailed: HileiaErrorMin + 9, // token验证失败
  OperationFailed: HileiaErrorMin + 10 // 操作失败
})

export const COC_ERR_CODE = Object.freeze({
  CANCELED: 22022, // 请求协作详情时，提示已取消
  MEMBER_REMOVED: 22023 // 当前成员被移除
})

export const PLATFORM_HTTP_RETCODE = Object.freeze({
  Ok: 0, // 成功
  NOLOGIN: 50028, // 未登录
  NOGRANT: 50042, // 无权限
})

export const INVITE_STATUS = Object.freeze({
  WAIT_OPS: 0, // 等待对方处理
  RECEIVE: 1, // 收到对方的添加申请
  ACCEPT: 2, // 申请被同意
  REJECT: 3, // 申请被对方拒绝
  ACCEPT_YOU: 4, // 同意对方申请
  REJECT_YOU: 5, // 拒绝对方申请
})

export const PAGE_NAME = Object.freeze({
  Login: 'Login',
  SigninToCode: 'SigninToCode',
  Home: 'CoopeList',
  Organ: 'Organ',
  Exception: 'Exception',
  Talking: 'Talking',
  Parsing: 'Parsing',
  StartApp: 'StartApp',
})

export const CURRENT_DOMAIN = location.hostname

export const CROSS_SUBDOMAIN = `.${CURRENT_DOMAIN}`

export const GLASSES_PAGE_NAME = Object.freeze({
  Login: 'ANDROI_LOGIN'
})

export const CACHE_KEY = Object.freeze({
  user: 'userBasicList',
  hash: 'userBasicListHash',
  LS_VERSION: 'LS_VERSION',
  NAV_REFRESH_TIME: 'NAV_REFRESH_TIME',
  NAV_TAG_COUNTER: 'NAV_TAG_COUNTER', // 有多少个窗口登录，登录时+1, 退出登录和关闭时-1
  NAV_TAG_LOGOUT: 'NAV_TAG_LOGOUT', // 当前标签页是否退出登录
  COOKIE_USER_ID: 'HILEIAUID',
  HILEIA_USER_INFO: '_hileia_user_info_',
  NOTY_PREFIX: '_hileia_notf_',
  MEMBER_AVATAR: '_hileia_member_avatar_',
  MEMBER_LINES: '_hileia_member_lines_',
  MEMBER_WHITE_BOARD_IMAGE: '_hileia_member_white_board_image_',
  MEMBER_WHITE_BOARD_LINES: '_hileia_member_white_board_lines_',
  TALKING_DURATION: '_hileia_talking_duration_',
  QUERY_COC_TAG_IDS: 'Q_COCTAGIDS', // 当前记录的协作查询条件tagIds
  QUERY_COC_CORP_IDS: 'Q_COCCORPIDS', // corpIds
  QUERY_COC_TIME_RANGE: 'Q_COCTIMERANGE', // [startTime, endTime]
})

export const ACTION_POSITION = Object.freeze({
  first: 'first',
  last: 'last'
})

export const RESOLUTION_OPTIONS = Object.freeze({
  '360P': '360p',
  '720P': '720p',
  '1080P': '1080p'
})

// 协作离开状态码
const memberStatusType = ESig.MemberStatusType
export const LEAVING_STATUS = [
  memberStatusType.OUTROOM_INIT,
  memberStatusType.OUTROOM_USER_CANCEL,
  memberStatusType.OUTROOM_USER_LEAVE,
  memberStatusType.OUTROOM_USER_REFUSE,
  memberStatusType.OUTROOM_USER_BUSY,
  memberStatusType.OUTROOM_USER_DROPLINE,
  memberStatusType.OUTROOM_USER_TIMEOUT,
  memberStatusType.OUTROOM_USER_MEDIAERR,
  memberStatusType.OUTROOM_SYSTEM_CLOSE,
  memberStatusType.OUTROOM_SYSTEM_ERR,
  memberStatusType.OUTROOM_USER_KICKOUT,
  memberStatusType.OUTROOM_MAX,
]

export const OAUTH_PLATFORM_TYPE = 5

export const CONFERENCE_STATE_OPTIONS = Object.freeze({
  get 1() { return i18n.tc('home.ToStart') }, // 等待开始
  get 2() { return i18n.tc('home.InProgress') }, // 进行中
  get 3() { return i18n.tc('home.Over') }, // 已结束
  get 4() { return i18n.tc('home.Cancelled') }, // 已取消
})

export const CONFERENCE_STATE = Object.freeze({
  WAIT_START: 1,
  IN_PROGRESS: 2,
  CLOSED: 3,
  CANCELED: 4
})

export const CONFERENCE_CONFIRM_OPTIONS = Object.freeze({
  get 0() { return i18n.tc('home.Undetermined') }, // 未确定
  get 1() { return i18n.tc('home.Confirmed') }, // 已确定
  get 2() { return i18n.tc('home.Refused') } // 已拒绝
})

export const BOOL_NUMBER = Object.freeze({
  FALSE: 0,
  TRUE: 1
})

export const CONFERENCE_CONFIRM_STATUS = Object.freeze({
  WAIT_CONFIRM: 0,
  CONFIRMED: 1,
  REJETCED: 2
})

export const CONFERENCE_RESOLVE_OPTIONS = Object.freeze({
  get 1() { return i18n.tc('home.Solved') }, // 已解决
  get 2() { return i18n.tc('home.Unsolved') } // 未解决
})

export const CONFERENCE_RESOLVE_STATUS = Object.freeze({
  RESOLVED: 1,
  UNSOLVED: 2
})

export const CONFERENCE_ATTEND_OPTIONS = Object.freeze({
  get 1() { return i18n.tc('home.NotJoined') }, // 未加入
  get 2() { return i18n.tc('home.InMeeting') }, // 在会议中
  get 3() { return i18n.tc('home.LeaveMeeting') }, // 离开会议
})

export const CONFERENCE_ATTEND_STATUS = Object.freeze({
  NOT_JOIN: 1,
  JOINED: 2,
  LEAVE: 3
})

export const CONFERENCE_ACT_STATUS = Object.freeze({
  INVITE_NTY: 130, // 邀请参加会议
  UPDATE_NTY: 131, // 编辑会议
  FILES_NTY: 132, // 增加图片
  REMOVE_MEMBER_NTY: 133, // 移除成员
  CANCEL_NTY: 134, // 取消会议
  STOP_NTY: 135, // 关闭会议
})

export const LANGUAGE = Object.freeze({
  CHINESE: 'CN',
  CHINESE_BACKEND: 'zh', // 后端接口使用
  ENGLISH: 'US',
  ENGLISH_BACKEND: 'en', // 后端接口使用
})

export const SIGNALTYPES = Object.freeze({
  BEST: [1],
  BETTER: [2, 3],
  GOOD: [4],
  POOR: [5],
  NOT: [0, 6, 7, 8]
})
export const SIGNALTYPEDEFAULTVALUE = 1
